import React, { useState, useCallback, useRef, useEffect } from "react";
import "./ListNavigation.scss";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronRight } from "@fortawesome/free-solid-svg-icons";

const ListNavigation = ({ items = [], packageInView, courseInView }) => {
	const navigate = useNavigate();
	const [expandedIndex, setExpandedIndex] = useState(0);
	const [userOverride, setUserOverride] = useState(false);
	const panelsRef = useRef([]);
	const lastCourseInViewRef = useRef(null);

	const handleButtonClick = (id) => {
		sessionStorage.setItem("suppressExpand", "1");

		navigate(window.location.pathname, { replace: true });
		setTimeout(() => {
			navigate(`#courseId-${id}`);
		}, 16);
	};


	const togglePackage = useCallback((index) => {
		setUserOverride(true);
		setExpandedIndex((curr) => (curr === index ? null : index));
	}, []);

	useEffect(() => {
		if (!items || items.length === 0) {
			return;
		}
		if (userOverride) {
			return;
		}
		if (packageInView === null) {
			return;
		}
		const index = items.findIndex((p) => (p.Id) === packageInView);
		if (index !== -1 && index !== expandedIndex) {
			setExpandedIndex(index);
		}
	}, [items, packageInView, userOverride, expandedIndex]);

	useEffect(() => {
		if (courseInView === null) {
			return;
		}
		if (lastCourseInViewRef.current !== courseInView) {
			lastCourseInViewRef.current = courseInView;
			setUserOverride(false);
		}
	}, [courseInView]);

	return (
		<div className="list-navigation">
			<div className="list-navigation-item">
				{items.map((pkg, i) => {
					const isOpen = expandedIndex === i;
					const baseHeight = panelsRef.current[i]?.scrollHeight || "auto";
					const panelHeight = isOpen
						? (baseHeight === "auto" ? "auto" : baseHeight + 16)
						: 0;

					return (
						<div className={`package-block ${isOpen ? "is-open" : ""}`} key={pkg.package}>
							<p
								className="package-title"
								onClick={() => togglePackage(i)}
								role="button"
								aria-expanded={isOpen}
								tabIndex={0}
								onKeyDown={(e) => {
									if (e.key === "Enter" || e.key === " ") {
										togglePackage(i);
									}
								}}
							>
								<span>{pkg.package}</span>
								<FontAwesomeIcon
									icon={faChevronDown}
									className={`chevron ${isOpen ? "rotated" : ""}`}
								/>
							</p>

							<div
								className={`accordion-panel ${isOpen ? "open" : ""}`}
								style={{ height: panelHeight }}
								aria-hidden={!isOpen}
							>
								<div
									className="course-list"
									ref={(el) => (panelsRef.current[i] = el)}
								>
									{pkg.packageCourses.map((course) => (
										<p
											key={`${pkg.Id}-${course.Id}`}
											className={`course-title ${courseInView === course.Id && packageInView === pkg.Id ? "scrolled-to-course" : ""}`}
											onClick={() => handleButtonClick(course.Id)}
											role="link"
											tabIndex={0}
											onKeyDown={(e) => {
												if (e.key === "Enter" || e.key === " ") handleButtonClick(course.Id);
											}}
										>
											<span className="course-title-text">
												<span className="course-title-highlight"></span>
												<span className="course-title-text-name">{course.Name}</span>
											</span>
											<span className="course-scroll">
												<span className="course-scroll-icon">
													<FontAwesomeIcon icon={faChevronRight} className="chevron" />
												</span>
												<span className="course-scroll-text">scroll to</span>
											</span>
										</p>
									))}
								</div>
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default ListNavigation;
